// import React, { useState, useEffect } from "react";
// import { collection, getDocs } from "firebase/firestore";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import css from "./hero.module.css";
// import arrowImp from "../../img/arrowDownPick.png";
// import arrowLeft from "../../img/arrowInHerpLeft.png";
// import arrowRight from "../../img/arrowInHeroRight.png";
// import YouTube from "react-youtube";
// import { db } from "../../firebase";
// import Footer from "../standartComponent/footer/footer";
// import LitShow from "../standartComponent/litShow/litShow";
// import ProductForHero from "./productForHero";
// import { query, where } from "firebase/firestore";
// import { useRef } from "react";

// export default function Author({ windowDimensions }) {
//   const [products, setProducts] = useState([]);
//   const [heroes, setHeroes] = useState([]);
//   const [startIndex, setStartIndex] = useState(0);
//   const heroesPerPage = 3;
//   const [selectedHero, setSelectedHero] = useState(null);
//   const location = useLocation();
//   const scrollRef = useRef(null);

//   const navigate = useNavigate();
//   const { id } = useParams();
//   const scrollLeft = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({ left: -300, behavior: "smooth" }); // Прокрутка вліво
//     }
//   };

//   const scrollRight = () => {
//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({ left: 300, behavior: "smooth" }); // Прокрутка вправо
//     }
//   };
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]);

//   useEffect(() => {
//     const fetchHeroes = async () => {
//       try {
//         const heroesRef = collection(db, "author");
//         const querySnapshot = await getDocs(heroesRef);
//         const heroData = querySnapshot.docs.map((doc) => doc.data());

//         setHeroes(heroData);

//         if (typeof id === "undefined") {
//           setSelectedHero(heroData[0]);
//         } else {
//           const selected = heroData.find((hero) => hero.uid === id);
//           setSelectedHero(selected);

//           // Обчислення стартового індексу для вибраного автора
//           const selectedIndex = heroData.findIndex((hero) => hero.uid === id);
//           if (selectedIndex !== -1) {
//             setStartIndex(
//               Math.floor(selectedIndex / heroesPerPage) * heroesPerPage
//             );
//           }
//         }
//       } catch (error) {
//         console.error("Помилка при отриманні документів:", error);
//       }
//     };

//     fetchHeroes();
//   }, [id]);

//   const normalizeString = (str) => {
//     if (!str) return ""; // Якщо значення undefined або null, повертаємо порожній рядок
//     return String(str) // Перетворюємо значення у рядок
//       .toLowerCase()
//       .replace(/\./g, "")
//       .replace(/\s+/g, " ")
//       .trim();
//   };
//   // useEffect(() => {
//   //   if (selectedHero && selectedHero.name) {
//   //     const fetchProducts = async () => {
//   //       try {
//   //         const q = query(collection(db, "product")); // Отримуємо всі товари
//   //         const querySnapshot = await getDocs(q);

//   //         // 🔹 Фільтруємо товари вручну, перевіряючи часткове співпадіння
//   //         const fetchedProducts = querySnapshot.docs
//   //           .map((doc) => doc.data())
//   //           .filter(
//   //             (product) =>
//   //               product.textAutor &&
//   //               normalizeString(selectedHero.name).includes(
//   //                 normalizeString(product.textAutor)
//   //               )
//   //           );

//   //         console.log("fetchedProducts", fetchedProducts);
//   //         setProducts(fetchedProducts);
//   //       } catch (error) {
//   //         console.log("Error fetching products:", error);
//   //       }
//   //     };

//   //     fetchProducts();
//   //   }
//   // }, [selectedHero]);
//   const extractLastName = (fullName) => {
//     if (typeof fullName !== "string" || !fullName.trim()) return "";
//     return fullName.split(" ")[0]; // Беремо перше слово (прізвище)
//   };
//   useEffect(() => {
//     if (selectedHero && selectedHero.name) {
//       const fetchProducts = async () => {
//         try {
//           const q = query(collection(db, "product"));
//           const querySnapshot = await getDocs(q);

//           const fetchedProducts = querySnapshot.docs
//             .map((doc) => doc.data())
//             .filter((product) => {
//               const authorLastName = extractLastName(selectedHero.name);
//               const productAuthorLastName = extractLastName(product.textAutor);
//               const productPicWriterLastName = extractLastName(
//                 product.picWriter
//               );

//               return (
//                 authorLastName &&
//                 (authorLastName === productAuthorLastName ||
//                   authorLastName === productPicWriterLastName)
//               );
//             });

//           console.log("Знайдені книги:", fetchedProducts);
//           setProducts(fetchedProducts);
//         } catch (error) {
//           console.log("Помилка при отриманні товарів:", error);
//         }
//       };

//       fetchProducts();
//     }
//   }, [selectedHero]);
//   const handleClickLeft = () => {
//     setStartIndex((prevIndex) => Math.max(0, prevIndex - heroesPerPage));
//   };

//   const handleClickRight = () => {
//     const maxIndex = Math.max(0, heroes.length - heroesPerPage);
//     setStartIndex((prevIndex) => Math.min(maxIndex, prevIndex + heroesPerPage));
//   };

//   const handleHeroClick = (hero) => {
//     setSelectedHero(hero);
//   };
//   useEffect(() => {
//     if (selectedHero && scrollRef.current) {
//       const selectedElement = scrollRef.current.querySelector(
//         `[data-uid='${selectedHero.uid}']`
//       );

//       if (selectedElement) {
//         selectedElement.scrollIntoView({
//           behavior: "smooth",
//           block: "nearest",
//           inline: "center",
//         });
//       }
//     }
//   }, [selectedHero]);
//   return (
//     <div>
//       <div className={css.allBooksWrap}>
//         <div className={css.allHero}>
//           <p className={css.yourPerfectHero}>
//             Майстри, яких представляє видавництво “Час майстрів”
//             <br />
//             <span className={css.yourPerfectHeroSpan}>
//               відкриті до безпосереднього спілкування з дітьми, батьками та
//               спеціалістами
//             </span>
//           </p>
//           <div className={css.ageWrap}>
//             <div className={css.chousBooksSelect}>
//               <select
//                 className={css.customSelect}
//                 value={heroes.indexOf(selectedHero)}
//                 onChange={(e) => setSelectedHero(heroes[e.target.value])}
//               >
//                 <option className={css.customOpin} value={0}>
//                   Автор
//                 </option>
//                 {heroes.map((hero, index) => (
//                   <option className={css.customOpin} value={index} key={index}>
//                     {hero.name}
//                   </option>
//                 ))}
//               </select>
//               <img src={arrowImp} className={css.customArrowSelect} />
//             </div>
//           </div>
//         </div>

//         <div className={css.autorListSmal}>
//           <img
//             src={arrowLeft}
//             onClick={scrollLeft}
//             className={css.arrowLeftSt}
//           />
//           {/* <div className={css.autorListSmalNew} ref={scrollRef}>
//             {heroes.map((hero, index) => (
//               <div
//                 key={index}
//                 onClick={() => handleHeroClick(hero)}
//                 className={css.imgAutorWrapSmall}
//               >
//                 <img
//                   src={hero.foto}
//                   className={`${css.imgAutorSmall} ${
//                     selectedHero && selectedHero.uid === hero.uid
//                       ? css.selectedHeroImage
//                       : ""
//                   }`}
//                 />
//                 <p className={css.autorNameM}>{hero.name}</p>
//                 <p className={css.autorNameMSma}>
//                   Автор книги:&nbsp;{hero.book}
//                 </p>
//                 <p className={css.autorNameMbigCol}>{hero.descSecond}</p>
//               </div>
//             ))}
//           </div> */}
//           <div className={css.autorListSmalNew} ref={scrollRef}>
//             {heroes.map((hero, index) => (
//               <div
//                 key={index}
//                 data-uid={hero.uid}
//                 onClick={() => handleHeroClick(hero)}
//                 className={css.imgAutorWrapSmall}
//               >
//                 <img
//                   src={hero.foto}
//                   className={`${css.imgAutorSmall} ${
//                     selectedHero && selectedHero.uid === hero.uid
//                       ? css.selectedHeroImage
//                       : ""
//                   }`}
//                 />
//                 <p className={css.autorNameM}>{hero.name}</p>
//                 <p className={css.autorNameMSma}>
//                   Автор книги:&nbsp;{hero.book}
//                 </p>
//                 <p className={css.autorNameMbigCol}>{hero.descSecond}</p>
//               </div>
//             ))}
//           </div>
//           <img
//             src={arrowRight}
//             onClick={scrollRight}
//             className={css.arrowRightSt}
//           />
//         </div>
//       </div>
//       <div className={css.arrowWrap}></div>

//       {selectedHero && (
//         <div className={css.wrapHeroBigFoto}>
//           <div className={css.wrapHeroBigFotoTwo}>
//             <div className={css.imgAutorWrapBig}>
//               <img src={selectedHero.foto} className={css.imgAutorBig} />
//             </div>
//             <div className={css.descHeroOP}>
//               <h1 className={css.heroName}>{selectedHero.name}</h1>
//               <div className={css.descrWithDot}>
//                 <div className={css.dot}></div>
//                 <p className={css.dotP}>{selectedHero.descOne}</p>
//               </div>
//               <div className={css.descrWithDot}>
//                 <div className={css.dot}></div>
//                 <p className={css.dotP}>{selectedHero.descSecond}</p>
//               </div>
//               <p className={css.whatBook}>
//                 {selectedHero.autor}&nbsp; {selectedHero.book}
//               </p>
//             </div>
//           </div>
//           <div className={css.yellowFitchWrap}>
//             <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
//             <div className={css.hvist}></div>
//           </div>
//           <div className={css.historiCreateBlock}>
//             <p className={css.hictoryP}>{selectedHero.history}</p>
//           </div>
//           <div className={css.blockInturv}>
//             <div className={css.blockInturvSmall}>
//               <h3 className={css.inturvH3}>Інтерв’ю з автором</h3>
//               <p className={css.inturvP}>{selectedHero.internOne}</p>
//               <p className={css.inturvP}>{selectedHero.internSecond}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className={css.theSameBooksWrap}>
//         <div className={css.theSameBooksWrapSmall}>
//           <h4 className={css.theSameH4}>Книги автора</h4>
//           <div className={css.smallBookLikeWrap}>
//             {products.map((el, index) => {
//               if (index < 3) {
//                 return <ProductForHero el={el} key={index} />;
//               }
//             })}
//           </div>
//         </div>
//       </div>

//       <div className={css.videoBlockWrap}>
//         <div className={css.videoBlockWrapSmall}>
//           <h4 className={css.seeBook}>Відеознайомство</h4>
//           <div className={css.video}>
//             {selectedHero && (
//               <>
//                 {windowDimensions && (
//                   <YouTube
//                     videoId={selectedHero.video}
//                     opts={{ width: "1193.03px", height: "714.56px" }}
//                   />
//                 )}
//                 {!windowDimensions && (
//                   <YouTube
//                     videoId={selectedHero.video}
//                     opts={{ width: "300px", height: "196px" }}
//                   />
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       <LitShow />
//       <Footer />
//     </div>
//   );
// }
import React, { useState, useEffect, useRef } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import YouTube from "react-youtube";
import css from "./hero.module.css";
import arrowImp from "../../img/arrowDownPick.png";
import arrowLeft from "../../img/arrowInHerpLeft.png";
import arrowRight from "../../img/arrowInHeroRight.png";
import { db } from "../../firebase";
import Footer from "../standartComponent/footer/footer";
import LitShow from "../standartComponent/litShow/litShow";
import ProductForHero from "./productForHero";

export default function Author({ windowDimensions }) {
  const [products, setProducts] = useState([]);
  const [heroes, setHeroes] = useState([]);
  const [selectedHero, setSelectedHero] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const scrollRef = useRef(null);
  const heroInfoRef = useRef(null); // 🔹 Референс для блоку автора

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const fetchHeroes = async () => {
      try {
        const heroesRef = collection(db, "author");
        const querySnapshot = await getDocs(heroesRef);
        const heroData = querySnapshot.docs.map((doc) => doc.data());

        setHeroes(heroData);

        if (!id) {
          setSelectedHero(heroData[0]);
        } else {
          const selected = heroData.find((hero) => hero.uid === id);
          setSelectedHero(selected || heroData[0]);
        }
      } catch (error) {
        console.error("Помилка отримання авторів:", error);
      }
    };

    fetchHeroes();
  }, [id]);

  useEffect(() => {
    if (selectedHero && scrollRef.current) {
      const selectedElement = scrollRef.current.querySelector(
        `[data-uid='${selectedHero.uid}']`
      );

      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [selectedHero]);

  // 🔹 Прокручуємо сторінку до блоку автора при зміні selectedHero
  useEffect(() => {
    if (heroInfoRef.current) {
      heroInfoRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedHero]);

  // useEffect(() => {
  //   if (selectedHero?.name) {
  //     const fetchProducts = async () => {
  //       try {
  //         const q = query(collection(db, "product"));
  //         const querySnapshot = await getDocs(q);

  //         const fetchedProducts = querySnapshot.docs
  //           .map((doc) => doc.data())
  //           .filter((product) => product.textAutor === selectedHero.name);

  //         setProducts(fetchedProducts);
  //       } catch (error) {
  //         console.error("Помилка отримання книг автора:", error);
  //       }
  //     };

  //     fetchProducts();
  //   }
  // }, [selectedHero]);
  useEffect(() => {
    if (selectedHero?.name) {
      const fetchProducts = async () => {
        try {
          const q = query(collection(db, "product"));
          const querySnapshot = await getDocs(q);

          const allProducts = querySnapshot.docs.map((doc) => doc.data());

          const selectedNameFirstWord = selectedHero.name
            .split(" ")[0]
            .toLowerCase();

          const filtered = allProducts.filter((product) => {
            const autor = product.textAutor;

            // Перевіряємо, чи поле автор взагалі існує і чи це рядок
            if (typeof autor !== "string") {
              console.warn("⚠️ Пропущено товар з невалідним textAutor:", autor);
              return false;
            }

            const productFirstWord = autor.split(" ")[0].toLowerCase();
            const isMatch = productFirstWord === selectedNameFirstWord;

            return isMatch;
          });

          setProducts(filtered);
        } catch (error) {
          console.error("❌ Помилка отримання книг автора:", error);
        }
      };

      fetchProducts();
    }
  }, [selectedHero]);

  const scrollLeft = () =>
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  const scrollRight = () =>
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });

  return (
    <div>
      <div className={css.allBooksWrap}>
        <div className={css.allHero}>
          <p className={css.yourPerfectHero}>
            Майстри, яких представляє видавництво “Час майстрів”
            <br />
            <span className={css.yourPerfectHeroSpan}>
              відкриті до безпосереднього спілкування з дітьми, батьками та
              спеціалістами
            </span>
          </p>
          <div className={css.ageWrap}>
            <div className={css.chousBooksSelect}>
              <select
                className={css.customSelect}
                value={heroes.indexOf(selectedHero)}
                onChange={(e) => setSelectedHero(heroes[e.target.value])}
              >
                {heroes.map((hero, index) => (
                  <option key={index} className={css.customOpin} value={index}>
                    {hero.name}
                  </option>
                ))}
              </select>
              <img
                src={arrowImp}
                className={css.customArrowSelect}
                alt="Arrow"
              />
            </div>
          </div>
        </div>

        <div className={css.autorListSmal}>
          <img
            src={arrowLeft}
            onClick={scrollLeft}
            className={css.arrowLeftSt}
            alt="Scroll Left"
          />
          <div className={css.autorListSmalNew} ref={scrollRef}>
            {heroes.map((hero, index) => (
              <div
                key={index}
                data-uid={hero.uid}
                onClick={() => setSelectedHero(hero)}
                className={css.imgAutorWrapSmall}
              >
                <img
                  src={hero.foto}
                  className={`${css.imgAutorSmall} ${
                    selectedHero?.uid === hero.uid ? css.selectedHeroImage : ""
                  }`}
                  alt={hero.name}
                />
                <p className={css.autorNameM}>{hero.name}</p>
                <p className={css.autorNameMSma}>{hero.book}</p>
                {/* <p className={css.autorNameMbigCol}>{hero.descSecond}</p> */}
              </div>
            ))}
          </div>
          <img
            src={arrowRight}
            onClick={scrollRight}
            className={css.arrowRightSt}
            alt="Scroll Right"
            ref={heroInfoRef}
          />
        </div>
      </div>

      {selectedHero && (
        <div className={css.wrapHeroBigFoto}>
          <div className={css.wrapHeroBigFotoTwo}>
            <div className={css.imgAutorWrapBig}>
              <img
                src={selectedHero.foto}
                className={css.imgAutorBig}
                alt="Author"
              />
            </div>
            <div className={css.descHeroOP}>
              <h1 className={css.heroName}>{selectedHero.name}</h1>
              <p className={css.dotP}>{selectedHero.descOne}</p>
              <p className={css.dotP}>{selectedHero.descSecond}</p>
              <p className={css.whatBook}>
                {selectedHero.autor}&nbsp; {selectedHero.book}
              </p>
            </div>
          </div>

          <div className={css.yellowFitchWrap}>
            <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
            <div className={css.hvist}></div>
          </div>

          <div className={css.historiCreateBlock}>
            <p className={css.hictoryP}>{selectedHero.history}</p>
          </div>

          <div className={css.blockInturv}>
            <div className={css.blockInturvSmall}>
              <h3 className={css.inturvH3}>Інтерв’ю з автором</h3>
              <p className={css.inturvP}>{selectedHero.internOne}</p>
              <p className={css.inturvP}>{selectedHero.internSecond}</p>
            </div>
          </div>
        </div>
      )}

      <div className={css.theSameBooksWrap}>
        <div className={css.theSameBooksWrapSmall}>
          <h4 className={css.theSameH4}>Книги автора</h4>
          <div className={css.smallBookLikeWrap}>
            {products.slice(0, 3).map((el, index) => (
              <ProductForHero el={el} key={index} />
            ))}
          </div>
        </div>
      </div>

      <div className={css.videoBlockWrap}>
        <div className={css.videoBlockWrapSmall}>
          <h4 className={css.seeBook}>Відеознайомство</h4>
          <div className={css.video}>
            {selectedHero?.video && (
              <YouTube
                videoId={selectedHero.video}
                opts={{ width: "1193.03px", height: "714.56px" }}
              />
            )}
          </div>
        </div>
      </div>

      <LitShow />
      <Footer />
    </div>
  );
}
